import { request } from '../request'
//批量开启/关闭任务
export function batchAdd(params) {
  return request({
    url: '/quota/surveyJobExecution/batchOpenOrClose',
    method: 'put',
    data: params
  })
}
//查询任务列表
// export function searchList(params) {
//     return request({
//       url: "/quota/surveyJobExecution/list/{surveyId}",
//       method: "get",
//       params: params
//     })
//   }
// export const searchList = (id) => {
//   return request.get("/quota/surveyJobExecution/list/" + id)
// }
export function searchList(params) {
  return request({
    url: '/quota/surveyJobExecution/list',
    method: 'get',
    params: params
  })
}
//调查员
export function peopleList(params) {
  return request({
    url: '/admin/user/getTenantStaffList',
    method: 'get',
    params: params
  })
}
//批量创建面访任务
export function plCreat(params) {
  return request({
    url: '/quota/surveyJobExecution/addList',
    method: 'post',
    data: params
  })
}
//检验手机号和用户是否匹配
export function checkUser(params) {
  return request({
    url: '/quota/surveyJobExecution/checkUser',
    method: 'post',
    data: params
  })
}
//检验手机号和用户是否匹配
export const sinviteAgain = id => {
  return request.put('/quota/surveyJobExecution/inviteAgain/' + id)
}
